import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/usuario.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-solicitud-especialidad-prestacion',
    templateUrl: './solicitud-especialidad-prestacion.component.html',
    styleUrls: ['./solicitud-especialidad-prestacion.component.css'],
    standalone: false
})
export class SolicitudEspecialidadPrestacionComponent implements OnInit {
  private readonly _usuarioService = inject(UsuarioService);
  private readonly _authService = inject(AuthService);
  private readonly _loadingService = inject(LoadingService);

  private readonly _router = inject(Router);
  private readonly _location = inject(Location);
  private readonly _fb = inject(FormBuilder);

  // estado
  error = signal<string>('');
  isFinished = signal<boolean>(false);
  loading = computed(() => this._loadingService.isLoading()); // no se usa en html (pero sirve si querés)

  // form
  solicitudServicioEspecialidad = this._fb.group({
    especialidad: ['', Validators.required],
    prestacion: ['', Validators.required],
  });

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
        return;
      }
    });
  }

  async solicitudEspecialidadPrestacion(): Promise<void> {
    this.error.set('');

    // Validaciones
    if (this.solicitudServicioEspecialidad.invalid) {
      this.solicitudServicioEspecialidad.markAllAsTouched();
      this.error.set('Completá los campos requeridos.');
      return;
    }

    const v = this.solicitudServicioEspecialidad.value;
    const x_especialidad = (v.especialidad ?? '').trim();
    const x_prestacion = (v.prestacion ?? '').trim();

    if (!x_especialidad) {
      this.error.set('Debe ingresar una Especialidad');
      return;
    }
    if (!x_prestacion) {
      this.error.set('Debe ingresar una Prestación');
      return;
    }

    await this._loadingService.run(async () => {
      try {
        // Aseguro sesión por si esta pantalla se abrió "colgada" de una navegación rara
        await this._authService.ensureSession();

        await firstValueFrom(
          this._usuarioService.solicitudEspecialidadPrestacion(
            this._usuarioService.usuario().x_email!,
            x_especialidad,
            x_prestacion
          )
        );

        this.isFinished.set(true);
      } catch (e) {
        console.error(e);
        this.error.set('Error al enviar la solicitud');
      }
    });
  }

  back(): void {
    this._location.back();
  }
}
